import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./RevisarCotacao.css";
import api from '../../../services/api';
import { Grid, TextField } from '@mui/material';
import API_CONFIG from '../../../config/api.config';


const RevisarCotacao = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Sempre pega do localStorage
  const admId = localStorage.getItem('idUsuario');
  //console.log('ID do ADM:', admId);

  useEffect(() => {
    const tipoUsuario = localStorage.getItem('tipoUsuario');
    if (tipoUsuario !== 'ADM') {
      navigate('/');
    }
  }, [navigate]);

  const [isRevisarcotacaoMenuExpanded, setIsRevisarcotacaoMenuExpanded] = useState(false);
  const [revisarcotacaoSearchTerm, setRevisarcotacaoSearchTerm] = useState('');
  const [revisarcotacaoDataInicio, setRevisarcotacaoDataInicio] = useState('');
  const [revisarcotacaoDataFim, setRevisarcotacaoDataFim] = useState('');
  const [revisarcotacaoCurrentPage, setRevisarcotacaoCurrentPage] = useState(1);
  const [revisarcotacaoCompras, setRevisarcotacaoCompras] = useState([]);
  const [revisarcotacaoLoading, setRevisarcotacaoLoading] = useState(false);
  const [revisarcotacaoPaginacao, setRevisarcotacaoPaginacao] = useState(null);

  // Buscar compras da API
  const revisarcotacaoBuscarCompras = async (page = revisarcotacaoCurrentPage) => {
    try {
      setRevisarcotacaoLoading(true);
      const params = { page };
      if (revisarcotacaoDataInicio) params.data_inicio = revisarcotacaoDataInicio;
      if (revisarcotacaoDataFim) params.data_fim = revisarcotacaoDataFim;
      const response = await api.get(API_CONFIG.ENDPOINTS.COMPRAS.LISTAR_TODAS_COMPRAS, { params });
      if (response.data.status && response.data.compras) {
        setRevisarcotacaoCompras(response.data.compras.data);
        setRevisarcotacaoPaginacao(response.data.compras);
      } else {
        setRevisarcotacaoCompras([]);
        setRevisarcotacaoPaginacao(null);
      }
    } catch (error) {
      setRevisarcotacaoCompras([]);
      setRevisarcotacaoPaginacao(null);
    } finally {
      setRevisarcotacaoLoading(false);
    }
  };

  // Filtro por número da compra
  const revisarcotacaoFiltrarCompras = () => {
    if (!revisarcotacaoSearchTerm) return revisarcotacaoCompras;
    const id = parseInt(revisarcotacaoSearchTerm.replace(/[^\d]/g, ''));
    if (!id) return [];
    return revisarcotacaoCompras.filter(compra => compra.COM_ID === id);
  };

  useEffect(() => {
    revisarcotacaoBuscarCompras();
    // eslint-disable-next-line
  }, [revisarcotacaoCurrentPage]);

  useEffect(() => {
    const handleRevisarcotacaoMenuChange = (event) => {
      setIsRevisarcotacaoMenuExpanded(!event.detail.isCollapsed);
    };
    window.addEventListener('menuStateChange', handleRevisarcotacaoMenuChange);
    return () => window.removeEventListener('menuStateChange', handleRevisarcotacaoMenuChange);
  }, []);

  const handleRevisarcotacaoViewSolicitacao = (compra) => {
    navigate('/adm/revisarcotacao/revisar', { state: { compraId: compra.COM_ID } });
  };

  const handleBuscar = () => {
    setRevisarcotacaoCurrentPage(1);
    revisarcotacaoBuscarCompras(1);
  };

  const revisarcotacaoNextPage = () => {
    if (revisarcotacaoPaginacao?.next_page_url) {
      setRevisarcotacaoCurrentPage(revisarcotacaoCurrentPage + 1);
    }
  };

  const revisarcotacaoPrevPage = () => {
    if (revisarcotacaoPaginacao?.prev_page_url) {
      setRevisarcotacaoCurrentPage(revisarcotacaoCurrentPage - 1);
    }
  };

  const comprasFiltradas = revisarcotacaoFiltrarCompras();

  return (
    <div className={`revisarcotacao-home-container ${isRevisarcotacaoMenuExpanded ? 'menu-expanded' : ''}`}>
      <div className="revisarcotacao-modal-wrapper">
        <h1 className="revisarcotacao-modal-title">Revisar Compras</h1>
        <div className="revisarcotacao-modal-content">
          <div className="revisarcotacao-search-container" style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
            <input
              type="text"
              placeholder="Digite o Nº da compra (ex: 2)"
              value={revisarcotacaoSearchTerm}
              onChange={(e) => setRevisarcotacaoSearchTerm(e.target.value)}
              className="revisarcotacao-search-input"
              style={{ minWidth: 180, maxWidth: 220, width: 180 }}
            />
            <TextField
              label="Data Início"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={revisarcotacaoDataInicio}
              onChange={(e) => setRevisarcotacaoDataInicio(e.target.value)}
              inputProps={{ max: revisarcotacaoDataFim }}
              style={{ minWidth: 150 }}
            />
            <TextField
              label="Data Fim"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={revisarcotacaoDataFim}
              onChange={(e) => setRevisarcotacaoDataFim(e.target.value)}
              inputProps={{ min: revisarcotacaoDataInicio }}
              style={{ minWidth: 150 }}
            />
            <button
              className="revisarcotacao-search-button"
              onClick={handleBuscar}
              style={{ height: 40, marginLeft: 4 }}
            >
              PROCURAR
            </button>
          </div>

          <div className="revisarcotacao-cards-grid">
            {revisarcotacaoLoading ? (
              <div className="revisarcotacao-loading">
                Carregando compras...
              </div>
            ) : comprasFiltradas && comprasFiltradas.length > 0 ? (
              comprasFiltradas.map((compra) => (
                <div key={compra.COM_ID} className="revisarcotacao-card">
                  <h2 className="revisarcotacao-card-title">Compra #{compra.COM_ID}</h2>
                  <div className="revisarcotacao-card-content">
                    <div className="revisarcotacao-card-info">
                      <strong>Fornecedor:</strong> {compra.cotacao?.COT_FOR_ID || 'Não informado'}
                    </div>
                    <div className="revisarcotacao-card-info">
                      <strong>Data:</strong> {compra.COM_DATA_VINCULACAO ? new Date(compra.COM_DATA_VINCULACAO).toLocaleDateString('pt-BR') : '-'}
                    </div>
                    <div className="revisarcotacao-card-info">
                      <strong>Status:</strong> {compra.cotacao?.COT_STATUS || '-'}
                    </div>
                    <div className="revisarcotacao-card-info">
                      <strong>Quantidade de itens:</strong> {compra.itens?.length || 0}
                    </div>
                    <button
                      className="revisarcotacao-ver-cotacao-btn"
                      onClick={() => handleRevisarcotacaoViewSolicitacao(compra)}
                    >
                      Revisar
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="revisarcotacao-no-results">
                Nenhuma compra encontrada.
              </div>
            )}
          </div>

          <div className="revisarcotacao-pagination">
            {revisarcotacaoPaginacao && (
              <>
                {revisarcotacaoPaginacao.prev_page_url && (
                  <button className="revisarcotacao-pagination-btn" onClick={revisarcotacaoPrevPage} disabled={revisarcotacaoLoading}>
                    Voltar
                  </button>
                )}

                <span className="revisarcotacao-pagination-info">
                  Página {revisarcotacaoPaginacao.current_page} de {revisarcotacaoPaginacao.last_page}
                </span>
                {revisarcotacaoPaginacao.next_page_url && (
                  <button className="revisarcotacao-pagination-btn" onClick={revisarcotacaoNextPage} disabled={revisarcotacaoLoading}>
                    Próximo
                  </button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default RevisarCotacao;